<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Import - Publications</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />

      <div class="row mt-2">
        <div class="col">
          <v-stepper alt-labels v-model="step">
            <v-stepper-header>
              <v-stepper-step step="1" editable>Publishers</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="2">Files</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3" editable>Publications</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="4" editable>Review</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="5" editable>Ingest</v-stepper-step>
            </v-stepper-header>
          </v-stepper>
        </div>
      </div>

      <div class="mt-7">
        <!--------- Providers ----------->
        <div class="row" v-show="step == 1">
          <div class="col">
            <PublisherList @onSelect="onSelectProvider($event)"></PublisherList>
          </div>
        </div>
        <!--------- End Providers -------->

        <!-- Publisher Files -->
        <div v-show="step == 2">
          <div class="row">
            <div class="col-8"><b>Publisher: </b> {{ PublisherName }}</div>
            <div class="col-4">
              <div class="float-right">
                <v-icon class="mr-2" @click="onRefresh()">mdi-cached</v-icon>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <!-- <th style="width: 50px"></th> -->
                      <th class="text-left">Files</th>
                      <th class="text-left">Total Record Count</th>
                      <th class="text-left">Selected Record Count</th>
                      <th class="text-left">Processed Record Count</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Last Updated Date</th>
                      <th style="width: 50px"></th>
                      <th style="width: 50px"></th>
                      <th style="width: 50px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in list" :key="item.id">
                      <td>{{ item.FileName }}</td>
                      <td>{{ item.TotalRecordCount }}</td>
                      <td>{{ item.SelectedRecordCount }}</td>
                      <td>{{ item.ImportedRecordCount }}</td>
                      <td>{{ item.ImportedStatusDesc }}</td>
                      <td>{{ item.JobEndTime | formatDateTime }}</td>
                      <td>
                        <v-icon
                          v-show="item.ImportedStatus == '6'"
                          @click="onPublications(item)"
                          >mdi-check-all</v-icon
                        >
                      </td>
                      <td>
                        <v-icon class="mr-2" @click="onProcessile(item)"
                          >mdi-file</v-icon
                        >
                      </td>
                      <td>
                        <v-icon
                          class="mr-2"
                          @click="onSelectFile(item)"
                          v-show="item.ImportedStatus >= 3"
                          >mdi-view-grid-outline</v-icon
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>
        </div>
        <!-- End Publisher Files -->

        <!----------- Publication List ------------->
        <div class="row" v-show="step == 3">
          <div class="col">
            <ImportPublicationList
              :PublisherName="PublisherName"
              :FileName="FileName"
              :FileId="FileId"
              :step="step"
              @onReview="onSelectReview($event)"
            ></ImportPublicationList>
          </div>
        </div>
        <!----------- End Publication List ------------->

        <!----------- Review Publication -------------->
        <div class="row" v-show="step == 4">
          <div class="col">
            <ReviewPublicationList
              :PublisherName="PublisherName"
              :FileName="FileName"
              :FileId="FileId"
              :SenderId="SenderId"
              :step="step"
              @onIngest="onIngest($event)"
            ></ReviewPublicationList>
          </div>
        </div>
        <!-----------End Review Publication -------------->

        <!----------- Review Publication -------------->
        <div class="row" v-show="step == 5">
          <div class="col">
            <IngestStatus
              :PublisherName="PublisherName"
              :FileName="FileName"
              :FileId="FileId"
              :SenderId="SenderId"
              :step="step"
            ></IngestStatus>
          </div>
        </div>
      </div>

      <!-- Steps ------------
      <div class="row">
        <div class="col">
          <div class="float-left" v-show="step != 0">
            <v-btn color="primary" @click="onBack()" class="mt-4">{{
              BackAction
            }}</v-btn>
          </div>
          <div class="float-right" v-show="step != 0">
            <v-btn color="primary" @click="onNext()" class="mt-4">{{
              NextAction
            }}</v-btn>
          </div>
        </div>
      </div>
      ----- End Steps -->
    </v-card>
    <!------------>

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="1000px">
        <v-card>
          <v-card-title>
            <span> {{SelectedFile}} - Publications</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div class="row" v-if="false">
              <div class="col">
                <div class="pl-3 col">
                  <v-text-field
                    v-model="Search"
                    label="Search"
                    required
                    append-outer-icon="mdi-table-search"
                    @click:append-outer="onSearch"
                    v-on:keyup.enter="onSearch()"
                  ></v-text-field>
                </div>
              </div><div class="col"></div>
            </div>
            <div class="row">
              <div class="col">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <!--<th class="text-left">Title</th>  IsThumbnailNotFound-->
                        <th class="text-left">ISBN</th>
                        <th class="text-left">Publication Found</th>
                        <th class="text-left">Publication Uploaded</th>
                        <th class="text-left">Publication Encripted</th>
                        <th class="text-left">Thumbnail Uploaded</th>
                        <th class="text-left">Metadata Uploaded</th>
                        <th class="text-left">Is Imported</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in listMataData" :key="item.id">
                        <!--<td>{{ item.Title }}</td>-->
                        <td>{{ item.ISBN }}</td>
                        <td>
                          <v-icon v-show="item.IsContentNotFound == false"
                            >mdi-check</v-icon
                          ><v-icon v-show="item.IsContentNotFound"
                            >mdi-close</v-icon
                          >
                        </td>
                        <td>
                          <v-icon v-show="item.isPublicationUploaded"
                            >mdi-check</v-icon
                          >
                          <v-icon
                            v-show="
                              !!item.isPublicationUploaded &&
                              !item.isPublicationUploaded
                            "
                            >mdi-close</v-icon
                          >
                          <!--<v-progress-circular v-show="IsNullCheck(item.isPublicationUploaded)" indeterminate></v-progress-circular>-->
                        </td>
                        <td>
                          <v-icon v-show="item.isContentEncripted"
                            >mdi-check</v-icon
                          ><v-icon
                            v-show="
                              !!item.isContentEncripted &&
                              !item.isContentEncripted
                            "
                            >mdi-close</v-icon
                          >
                        </td>
                        <td>
                          <v-icon v-show="item.isThumbnailUploaded"
                            >mdi-check</v-icon
                          ><v-icon
                            v-show="
                              !!item.isThumbnailUploaded &&
                              !item.isThumbnailUploaded
                            "
                            >mdi-close</v-icon
                          >
                        </td>
                        <td>
                          <v-icon v-show="item.isMetadataUploaded"
                            >mdi-check</v-icon
                          ><v-icon
                            v-show="
                              !!item.isMetadataUploaded &&
                              !item.isMetadataUploaded
                            "
                            >mdi-close</v-icon
                          >
                        </td>
                        <td>
                          <v-icon v-show="item.isImported">mdi-check</v-icon
                          ><v-icon
                            v-show="!!item.isImported && !item.isImported"
                            >mdi-close</v-icon
                          >
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <Pagination
                  :paging="paging"
                  v-on:next="onNextPage"
                  class="mt-5"
                />
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--------------------------->
  </div>
</template>

<script>
import * as api from "@/api";
import Notification from "@/components/Notification";
import PublisherList from "@/components/PublisherList";
import ImportPublicationList from "@/components/ImportPublicationList";
import ReviewPublicationList from "@/components/ReviewPublicationList";
import IngestStatus from "@/components/IngestStatus";
import Pagination from "@/components/Pagination";

export default {
  name: "ImportOnixPublications",
  components: {
    Notification,
    PublisherList,
    ImportPublicationList,
    ReviewPublicationList,
    IngestStatus,
    Pagination,
  },
  created() {
    this.getFiles();
  },
  computed: {
    ImportedStatusIcon() {
      return this.ImportedStatus == 1 || this.ImportedStatus == 2
        ? "mdi-file"
        : this.ImportedStatus == 3
        ? "mdi-file-send"
        : "";
    },
  },
  methods: {
    isDisabled(item) {
      return item.ImportedStatus == 0 || item.ImportedStatus == 7
        ? false
        : true;
    },
    getImportedStatusIcon(ImportedStatus) {
      return ImportedStatus == 1 || ImportedStatus == 2
        ? "mdi-file"
        : ImportedStatus == 3
        ? "mdi-file-send"
        : "";
    },
    getFiles() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .post("import/onix/files", this.selectedProvider)
          .then((response) => {
            this.list = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onRefresh() {
      this.getFiles();
    },
    onSelectProvider(provider) {
      console.log(provider);
      this.selectedProvider = provider;
      this.PublisherName = provider.sender;
      this.SenderId = provider.id;
      this.getFiles();
      this.step = 2;
      this.notify.type = 0;
      //this.onNext();
    },
    onProcessile(item) {
      console.log(item);
      this.FileName = item.FileName;
      this.FileId = item.FileId;
      this.notify.type = 0;
      this.prosessFile(item);
      //this.checkFileStatus(item)
    },
    onSelectFile(item) {
      this.FileName = item.FileName;
      this.FileId = item.FileId;
      this.step = 3;
      this.notify.type = 0;
    },
    onIngest(item) {
      //this.notify.type = 1;
      //this.notify.message = "Ingestion has been queued.";

      //this.FileName = item.FileName;
      //this.FileId = item;

      setTimeout(() => {
        this.notify.type = 0;
        this.step = 5;
      }, 2000);
    },

    prosessFile(obj) {
      console.log(obj);
      this.FileId = 0;
      new Promise((resolve, reject) => {
        api
          .post("import/onix/process/file", obj)
          .then((response) => {
            console.log(response.data);
            console.log(response.data.fileId);
            this.FileId = response.data.fileId;
            //this.checkFileStatus(response.data.ImportedStatus);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    checkFileStatus(importedStatus) {
      setTimeout(() => {
        if (importedStatus != 0 || importedStatus != 7) {
          this.onRefresh();
        }
      }, 2000);
    },

    waitforme(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },

    prosessFileStatusByFileId(fileId) {
      new Promise((resolve, reject) => {
        api
          .getByID("import/onix/file", fileId)
          .then((response) => {
            console.log("status");
            console.log(response);

            this.ImportedStatus = response.data.ImportedStatus;
            if (response.data.ImportedStatus == 3) {
              this.step += 1;
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    prosessFileStatusJobId(jobId) {
      new Promise((resolve, reject) => {
        api
          .getByID("import/onix/process/file/result", jobId)
          //.getByID("import/onix/process/file/result",jobId)
          .then((response) => {
            console.log("status");
            console.log(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onSelectReview(item) {
      console.log("onSelectReview ");
      this.notify.type = 0;
      this.step = 4;
      //this.onNext();
    },
    onEdit(obj) {},

    onNext() {
      console.log("this.step " + this.step);
      this.step += 1;

      console.log("this.step " + this.step);

      /*
      if (this.step == 2) {
        this.NextAction = "Process";
        //this.getMetadata();
        this.notify.errors = [];
        console.log(this.list);
        let objs = this.list.filter((f) => f.isSelected == true);
        console.log("objs " + objs);
        if (objs == "" || objs.lenght == 0) {
          this.notify.type = 4;
          this.notify.errors.push("Please select at least one file");
          this.onBack();
          return;
        }
        this.FileName = objs[0].FileName;
      } else if (this.step == 3) {
        this.processData();
      }*/
    },
    onBack() {
      console.log("this.step " + this.step);
      this.step -= 1;

      console.log("this.step " + this.step);

      if (this.step == 2) {
        this.NextAction = "Process";
        this.getMetadata();
      } else if (this.step == 3) {
        this.processData();
      }
    },
    processData() {},
    onPublications(item) {
      this.paging.page = 1;
      this.selectedFileId = item.FileId;
      this.SelectedFile = item.FileName;
      this.getMetadata(item.FileId);
      this.dialog = true;
    },
    getMetadata(FileId) {
      this.listMataData = [];
      new Promise((resolve, reject) => {
        api
          //.getAll("import/onix/metadata/" + fileName)
          .getByPagin("import/onix/metadata/" + FileId + "/ingest", this.paging)
          .then((response) => {
            //this.listMataData = response.data;
            this.listMataData = response.data.data;
            this.paging.count = response.data.count;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onSearch(){
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getMetadata(this.selectedFileId);
    },
    onNextPage(page) {
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getMetadata(this.selectedFileId);
    },
  },
  data() {
    return {
      id: 0,
      step: 1,
      list: [],
      listMataData: [],
      NextAction: "Next",
      BackAction: "Back",
      SelectedFile: "",
      SelectedFileCSV: "",
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      selectedProvider: {},
      FileName: "",
      PublisherName: "",
      jobId: 0,
      FileId: 0,
      ImportedStatus: 0,
      e1: 1,
      SenderId: 0,
      dialog: false,
      paging: { count: 10, page: 1, size: 5, keyword: "" },
      listMataData: [],
      selectedFileId:0
    };
  },
};
</script>
<style scoped>
.check-select {
  margin-top: -15px !important;
  margin-bottom: -15px !important;
}
</style>

<!--
Publishers = 1
Publisher File = 2
Publication = 3

-->


// WEBPACK FOOTER //
// src/views/Import/ImportOnixPublications.vue